"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const base_models_1 = require("@integration/base-models");
const BaseEntity_1 = tslib_1.__importDefault(require("../BaseEntity"));
class BaseProposition extends BaseEntity_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '513866', description: 'Proposition ID' }),
    tslib_1.__metadata("design:type", String)
], BaseProposition.prototype, "cdtId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-01-20T00:00:00.000Z',
        description: 'Date from which the proposition is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], BaseProposition.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-04-20T00:00:00.000Z',
        description: 'Date until when the proposition is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], BaseProposition.prototype, "validTo", void 0);
exports.default = BaseProposition;
